/* eslint-disable no-case-declarations */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import * as api from '../../../utils/api';
import CourseCard from './CourseCard';
import Box from '../../shared/atoms/Box';
import Heading from '../../shared/atoms/Heading';
import EmptyState from '../../shared/molecules/EmptyState';
import Button from '../../shared/atoms/Button';
import { ChatCtx } from '../../../contexts/ChatContext';

export default function AllCourses({ courses }) {
  const { t } = useTranslation();
  const { channels } = React.useContext(ChatCtx);
  const client = useSelector((s) => s.client);
  const [pendingConfirmationCourses, setPendingConfirmationCourses] = useState(
    [],
  );
  const [loadingPendingConfirmation, setLoadingPendingConfirmation] = useState(
    true,
  );

  // Fetch pending confirmation courses from separate endpoint
  useEffect(() => {
    const fetchPendingConfirmationCourses = async () => {
      if (!client?.id) return;

      try {
        setLoadingPendingConfirmation(true);
        const response = await api.get(`/clients/${client.id}/pending-courses`);

        if (response?.success && Array.isArray(response.data)) {
          setPendingConfirmationCourses(response.data);
        } else {
          setPendingConfirmationCourses([]);
        }
      } catch (error) {
        console.error('Error fetching pending confirmation courses:', error);
        setPendingConfirmationCourses([]);
      } finally {
        setLoadingPendingConfirmation(false);
      }
    };

    fetchPendingConfirmationCourses();
  }, [client?.id]);

  // Filter out PENDING_CONFIRMATION from regular courses
  const pendingCourses = courses.filter(
    (c) => c.status === '' && c.status !== 'PENDING_CONFIRMATION',
  );
  const pastCourses = courses.filter(
    (c) => c.status === 'TERMINE' || c.status === 'ANNULE',
  );
  return (
    <Box>
      {!!pendingConfirmationCourses.length && (
        <Box mb={10}>
          <Heading level={4} mb={{ xs: 2, lg: 4 }}>
            {t('requeststoconfirm')}
          </Heading>
          {pendingConfirmationCourses.map((course) => (
            <CourseCard key={course.id} course={course} channels={channels} />
          ))}
        </Box>
      )}
      {pendingCourses.length ? (
        <Box>
          <Heading level={4} mb={{ xs: 2, lg: 4 }}>
            {t('pendingrequest')}
          </Heading>
          {pendingCourses.map((course) => (
            <CourseCard key={course.id} course={course} channels={channels} />
          ))}
        </Box>
      ) : (
        <Box>
          <Heading level={4}>{t('pendingrequest')}</Heading>
          <Box alignItems="center">
            <EmptyState
              width="60%"
              title={t('account.nocourse.titles.1')}
              subTitle={t('account.nocourse.subtitles.1')}
              cta={
                <Button mt={2} alignSelf="center" to="/reparation">
                  {t('button.book')}
                </Button>
              }
            />
          </Box>
        </Box>
      )}
      {!!pastCourses.length && (
        <Box mt={10}>
          <Heading level={4}>{t('previousrequest')}</Heading>
          {pastCourses.map((course) => (
            <CourseCard key={course.id} course={course} channels={channels} />
          ))}
        </Box>
      )}
    </Box>
  );
}
